import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import cx from 'classnames';

import { useFilters, useSiteContext } from '@lib/context';

import Search from '@svg/search.svg';
import Exit from '@svg/exit.svg';

export const DesktopSearch = ({ searchActive, toggleSearch }) => {
  const { updateSearchQuery, nukeFilters } = useFilters();
  const { state } = useSiteContext();

  const { artistFilters, blogFilters, filters } = state;
  const hasFilters =
    artistFilters.instruments.length > 0 ||
    blogFilters.label ||
    filters.artists.length > 0 ||
    filters.locations.length > 0 ||
    filters.dates.from !== '' ||
    filters.dates.to !== '' ||
    filters.series.length > 0;

  return (
    <>
      <AnimatePresence exitBeforeEnter>
        {!searchActive && hasFilters && (
          <motion.button
            key={searchActive}
            onClick={() => nukeFilters()}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className='btn-standard bg-teal nav-hover transition-standard !w-[41px] !h-[41px] !p-0 flex items-center justify-center'>
            <Exit className='p-[6px]' />
          </motion.button>
        )}
      </AnimatePresence>
      <AnimatePresence exitBeforeEnter>
        <motion.button
          key={searchActive}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => {
            toggleSearch();
            updateSearchQuery('');
          }}
          className={cx(
            'w-[41px] h-[41px] bg-teal rounded-full flex items-center justify-center transition-standard',
            {
              'bg-opacity-10 hover:bg-opacity-100 nav-hover': !searchActive,
              'bg-opacity-0': searchActive,
            },
          )}>
          {searchActive ? (
            <Exit className='p-[6px]' />
          ) : (
            <Search className='p-[6px]' />
          )}
        </motion.button>
      </AnimatePresence>
    </>
  );
};
